import { API_BASE_URL, HUB_BASE_URL } from "@constants/env";
import { getAuthToken } from "@helpers/auth-provider";
import axios, { type InternalAxiosRequestConfig } from "axios";

const authorizationInterceptor = async (config: InternalAxiosRequestConfig) => {
	const token = await getAuthToken();
	if (token) {
		config.headers.Authorization = token;
	}

	return config;
};

export const hubAxios = axios.create();
hubAxios.defaults.baseURL = HUB_BASE_URL;
hubAxios.interceptors.request.use(authorizationInterceptor);

// For public hub endpoints (e.g. app config) that must work before auth
// is initialized — no authorization interceptor.
export const publicHubAxios = axios.create();
publicHubAxios.defaults.baseURL = HUB_BASE_URL;

export const apiAxios = axios.create();
apiAxios.defaults.baseURL = API_BASE_URL;
apiAxios.interceptors.request.use(authorizationInterceptor);

export const isAxiosError = axios.isAxiosError;
